import { Col, Grid, Row } from 'react-bootstrap';
import { withTranslation, WithTranslation } from 'react-i18next';
import * as React from 'react';

const AccountPending: React.FC<WithTranslation> = ({ t }) => {
    return (
        <div className="loginlayout">
            <Grid>
                <Row>
                    <Col>
                        <div className="login-form login">
                            <div className="pending-account-text">
                                Thank you for visiting MyMedGas, your account is
                                pending verification and activation from our
                                team. Typically this should take a day or two.
                                However, if you have any questions please don't
                                hesitate to email us at{' '}
                                <a href="mailto:mymedgas.support@beaconmedaes.com">
                                    mymedgas.support@beaconmedaes.com
                                </a>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Grid>
        </div>
    );
};

export default withTranslation('auth')(AccountPending);
